<template>
  <div>
    <search-sale-agent-monthly-performance
      statistic-type="stored"
      @submit="submitSearch"
    />

    <a-table
      :scroll="{ x: 'max-content' }"
      size="middle"
      :columns="columns"
      :data-source="data"
      :loading="loading"
      :pagination="false"
      :row-class-name="rowClassName"
      row-key="id"
    >
      <div slot="action" slot-scope="text, record">
        <a @click="recalculate(record)">重新计算</a>
      </div>
    </a-table>

    <pagination
      v-show="pagination.total_count > 0"
      :total-count="pagination.total_count"
      :page.sync="query.page"
      :per-page.sync="query.per_page"
      @change="fetchData"
    />
  </div>
</template>

<script>
import Pagination from '@/components/Pagination'
import SearchSaleAgentMonthlyPerformance from '@/views/sale_monthly_performances/info/Search'
import { findSaleAgentMonthlyStorePerformances, recalculateSaleMonthlyPerformance } from '@/api/sale_monthly_performance'
import { formatCurrency } from '@/utils/filter'
import { canViewSaleCostProfit, cardFloorDiff, packageFloorDiff, salePerformanceRecalculateContent } from '@/utils/sale_monthly_performance'
import { hasPermission } from '@/utils/permission'

export default {
  name: 'SaleMonthlyPerformanceInfoStoredList',
  components: {
    Pagination,
    SearchSaleAgentMonthlyPerformance
  },
  props: {
    id: {
      type: Number,
      required: true
    }
  },
  data() {
    return {
      data: [],
      loading: true,
      pagination: {
        total_count: 0
      },
      query: {}
    }
  },
  computed: {
    canRecalculate() {
      return hasPermission('sale_monthly_performances/recalculate')
    },
    canViewCostProfit() {
      return canViewSaleCostProfit(this.$store.getters.userRole)
    },
    columns() {
      const cols = [
        {
          title: '客户名称',
          dataIndex: 'agent_name'
        },
        {
          title: '账单类型',
          dataIndex: 'bill_type'
        },
        {
          title: '项目批次',
          dataIndex: 'agent_bill_no'
        }
      ]
      if (this.canRecalculate) {
        cols.push({
          title: '操作',
          width: 100,
          scopedSlots: { customRender: 'action' }
        })
      }
      cols.push(
        {
          title: '账单金额(元)',
          customRender: formatCurrency,
          dataIndex: 'amount'
        }
      )
      if (this.canViewCostProfit) {
        cols.push({
          title: '毛利核算(元)',
          customRender: formatCurrency,
          dataIndex: 'profit'
        })
      }
      cols.push(
        {
          title: '卡板费用(元)',
          customRender: formatCurrency,
          dataIndex: 'card_amount'
        },
        {
          title: '卡板底价(元)',
          customRender: formatCurrency,
          dataIndex: 'card_floor_amount'
        },
        {
          title: '卡板底价差(元)',
          customRender: (text, record) => formatCurrency(cardFloorDiff(record.card_amount, record.card_floor_amount)),
          dataIndex: 'card_floor_diff'
        },
        {
          title: '套餐费用(元)',
          customRender: formatCurrency,
          dataIndex: 'product_amount'
        },
        {
          title: '套餐底价(元)',
          customRender: formatCurrency,
          dataIndex: 'floor_amount'
        },
        {
          title: '套餐底价差(元)',
          customRender: (text, record) => formatCurrency(packageFloorDiff(record.product_amount, record.floor_amount)),
          dataIndex: 'sale_profit'
        },
        {
          title: '快递费(元)',
          customRender: formatCurrency,
          dataIndex: 'shipping_fee'
        },
        {
          title: '数量',
          dataIndex: 'cards_count'
        },
        {
          title: '账单时间',
          dataIndex: 'agent_bill_time'
        }
      )
      return cols
    }
  },
  created() {
    this.fetchData()
  },
  methods: {
    submitSearch(search) {
      this.query = Object.assign({},
        this.$options.data().query,
        { per_page: this.query.per_page },
        search)
      this.fetchData()
    },

    fetchData() {
      this.loading = true
      findSaleAgentMonthlyStorePerformances(this.id, this.query).then((res) => {
        if (res.code === 0) {
          this.data = res.data
          this.pagination = res.pagination
        }
        this.loading = false
      })
    },

    rowClassName(record) {
      if (this.canViewCostProfit && record.profit != null && Number(record.profit) < 0) {
        return 'sale-profit-negative-row'
      }
      if (cardFloorDiff(record.card_amount, record.card_floor_amount) < 0) {
        return 'sale-profit-negative-row'
      }
      if (packageFloorDiff(record.product_amount, record.floor_amount) < 0) {
        return 'sale-profit-negative-row'
      }
      return ''
    },

    recalculate(record) {
      this.$confirm({
        title: '重新计算该账单的销售业绩？',
        content: salePerformanceRecalculateContent(),
        onOk: () => recalculateSaleMonthlyPerformance({
          sale_agent_monthly_performance_id: record.id
        })
      })
    }
  }
}
</script>

<style>
.sale-profit-negative-row td {
  color: #f5222d !important;
}
</style>
